<template>
  <v-container>
    <v-row align="center" class="mb-15">
      <v-col></v-col>
      <v-col>
        <h3 class="display-2 text-center title-style">
          {{ $t("header.blog") }}
        </h3>
      </v-col>
      <v-col :class="$vuetify.rtl ? 'text-start' : 'text-end'">
        <v-btn text color="error" :to="localePath('/bloger')">
          {{ $t("header.more") }}
          <v-icon right
            >mdi-arrow-{{ $vuetify.rtl ? "left" : "right" }}-thin</v-icon
          >
        </v-btn>
      </v-col>
    </v-row>
    <div id="blog-list" class="blog-wrap mx-2">
      <v-row>
        <v-col
          v-for="(item, index) in posts"
          :key="index"
          md="4"
          cols="12"
          class="px-4"
        >
          <post-card
            :title="item.name[locale]"
            type="over"
            :desc="item.description[locale]"
            :date="item.createdAt"
            :img="getImage(item.img)"
            :href="`/bloger/${item.id}`"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<style scoped lang="scss">
@import "./blog-style";
</style>

<script>
import PostCard from "../Cards/PostCard";

export default {
  components: {
    PostCard,
  },
  data() {
    return {
      posts: [],
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  created() {
    this.$axios.get("/bloger/3").then((res) => {
      this.posts = res.data;
    });
  },
  methods: {
    getImage(icon) {
      return `${this.geteRelativeUrl()}file/assets?path=${icon}`;
    },
  },
};
</script>
